import type { DependencyList } from 'react';
import type { ElementModality, ElementType, TagType } from '@/app/types';

/**
 * Elements Selector 组件的通用 Props 接口
 */
export interface ElementsSelectorProps {
  /** 是否打开选择器 */
  isOpen: boolean;
  /** 关闭回调 */
  onClose: () => void;
  /** 选择元素回调 */
  onSelect: (elements: ElementType[], autoClose?: boolean) => void;
  /** 删除元素回调 */
  onDelete?: (ids: string[]) => void;
  /** 打开主体创建弹窗后的回调 */
  onCreateOpen?: () => void;
  /** 禁用的元素 ID 列表 */
  disabledIds?: string[];
  /** 剩余可选择的数量 */
  remainingSelections?: number;
  /** 最大参考数量，用于报错提示文案 */
  maxReferenceCount?: number;
  /** 元素变化回调 */
  onItemChange?: (element: ElementType) => void;
  /** 允许的元素类型 */
  allowedModalities?: Array<ElementModality>;
  /** 容器元素 */
  container?: HTMLDivElement | null;
  /** 待删除的元素 ID 列表 */
  pendingDeleteIds?: string[];
  /** 设置待删除的元素 ID 列表 */
  setPendingDeleteIds?: (ids: string[]) => void;
}

/**
 * 头部 Tab 枚举
 */
export enum HEAD_TAB {
  /** 我的元素 */
  REFERENCE = 'reference',
  /** 社区分享 */
  SHARE_REFERENCE = 'share_reference',
}
export interface ElementListProps {
  className?: string;
  selectedElements: ElementType[];
  tagSelectors?: string[];
  disabledIds?: string[];
  tags?: TagType[];
  elements: ElementType[];
  isLoading?: boolean;
  hasNextPage?: boolean;
  onLoadMore?: () => void;
  enableCreate?: boolean;
  toggleElementSelection?: (element: ElementType) => void;
  deeps?: DependencyList;
  onExpose?: (idx: number) => void;
  onDelete?: (ids: string[]) => void;
  onCreateOpen?: () => void;
}
